import i18n from '../../i18n';

export default {
  home: 'خانه',
  profile: 'نمایه',
  user: 'بدون اسم',
  tasks: 'وظیفه‌ها',
  companies: 'شرکت‌ها',
  exit: 'خروج',
  tasksManagement: 'مدیریت وظایف',
  companiesManagement: 'مدیریت شرکت‌ها',
  projectManagement: 'مدیریت پروژه‌ها',
  templateManagement: 'مدیریت قالب‌ها',
  inbox: 'صندوق پیام',
  code: 'کد',
  day: 'روز',
  minute: 'دقیقه',
  hour: 'ساعت',
  second: 'ثانیه',

  content: (providerName: string) => {
    if (providerName) {
      return `محتوای ${providerName}`;
    }
    return 'محتوا';
  },
  contentSettings: 'تنظیمات',
  tags: 'برچسب‌ها',
  providerTemplates: 'قالب‌ها',
  login: 'ورود',
  notFound: 'پیدا نشد',
  searchFor(itemName: string | string[] | undefined | null) {
    return `جستجو برای: ${itemName}`;
  },
};

type ProjectRoutes = 'create' | 'editor' | 'members' | 'task' | 'templates';

const routesName: { [name in ProjectRoutes]: string } = {
  create: i18n.t('createANewProject', { ns: 'companyManagement' }),
  editor: i18n.t('editor', { ns: 'companyManagement' }),
  members: i18n.t('projectMembers', { ns: 'companyManagement' }),
  task: '',
  templates: i18n.t('projectTemplates', { ns: 'companyManagement' }),
};

export const projectRoutesName = (
  type: ProjectRoutes,
  projectName?: string
) => {
  let title = routesName[type];
  if (projectName) {
    title = `${title} ${projectName}`;
  }
  return title;
};
